module.exports = __webpack_public_path__ + "img/user03.9d98cda1.png";